import { defineComponent, h } from "vue";

interface Props {
  text: string;
  tag: string;
}

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: "span",
    },
  },
  setup(props: Props) {
    return () => {
      const parts = props.text.split(/\*\*(.+?)\*\*/g);
      return h(
        props.tag,
        parts.map((part, i) => (i % 2 === 1 ? h("strong", part) : part)),
      );
    };
  },
});
